import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { useTranslation } from 'react-i18next';
import { getStaticElement } from '@store/HR/Payroll/ElementLinkSlice';

const useGetStaticElement = () => {
  const dispatch = useAppDispatch();
  const {
    StaticElement,
    loading2: loading,
    error2: error
  } = useAppSelector(state => state.ElementLink);

  const { i18n } = useTranslation();

  useEffect(() => {
    dispatch(getStaticElement());
    // if (StaticElement.length > 0) {
    // }
  }, []);

  // console.log(elementLink);

  const StaticElementCode = StaticElement?.map((item: any) => ({
    id: item.code,
    name: i18n.language === 'en' ? item.name : item.name2,
    value: `$${item.code}$`,
    description: `(static)`
    // description: `${i18n.language === 'en' ? item.name : item.name2} (static)`
  }));

  return { StaticElementCode, loading, error };
};

export default useGetStaticElement;
